// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group {
  border: 1px solid transparent;
}

button:disabled,
button[disabled],
button[disabled].btn,
button.btn:disabled {
  cursor: not-allowed !important;
}

input.form-control,
textarea.form-control,
select.form-control {
  border-color: #dee2e6 !important;
}

label.form-group-label {
  font-size: 0.8rem;
  margin-bottom: 5px;

}


label.radio-label,
label.checkbox-label {
  font-size: 0.8rem;
  margin-bottom: 5px;
  position: relative;
  padding-left: 20px;



}

label.radio-label input {
  margin-right: 5px;
  position: absolute;
  top: 5px;
  left: 0;
}


label.checkbox-label input {
  margin-right: 5px;
  position: absolute;
  top: 5px;
  left: 0;
}

span.required {
  display: inline-block;
  margin-left: 2px;
  font-size: 1rem
}

label[required]:after,
span.required:after {
  content: '*';
  font-size: 110%;
  color: red;
}


.alert-form-error {
  white-space: pre-wrap !important;
  font-size: 0.8rem;
  padding: 7px 15px !important;
}

.form-control.error {
  border-color: red !important;
}



.carret::after {
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  border-right: 2px solid black;
  border-bottom: 2px solid black;
  transform: rotate(225deg);
  margin-left: 7px;
  position: relative;
  top: 1px;
  transform: all 200ms;
}

.carret.desc::after {
  transform: rotate(45deg);
  top: -2px;
}



table tfoot th,
table tfoot td {
  font-weight: normal !important;
}`, "",{"version":3,"sources":["webpack://./src/css/forms.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;AAEpB;;;AAGA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;;;AAIpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB;AACF;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;;AAGA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;;;AAIA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;;;AAIA;;EAEE,8BAA8B;AAChC","sourcesContent":[".form-group {\r\n  border: 1px solid transparent;\r\n}\r\n\r\nbutton:disabled,\r\nbutton[disabled],\r\nbutton[disabled].btn,\r\nbutton.btn:disabled {\r\n  cursor: not-allowed !important;\r\n}\r\n\r\ninput.form-control,\r\ntextarea.form-control,\r\nselect.form-control {\r\n  border-color: #dee2e6 !important;\r\n}\r\n\r\nlabel.form-group-label {\r\n  font-size: 0.8rem;\r\n  margin-bottom: 5px;\r\n\r\n}\r\n\r\n\r\nlabel.radio-label,\r\nlabel.checkbox-label {\r\n  font-size: 0.8rem;\r\n  margin-bottom: 5px;\r\n  position: relative;\r\n  padding-left: 20px;\r\n\r\n\r\n\r\n}\r\n\r\nlabel.radio-label input {\r\n  margin-right: 5px;\r\n  position: absolute;\r\n  top: 5px;\r\n  left: 0;\r\n}\r\n\r\n\r\nlabel.checkbox-label input {\r\n  margin-right: 5px;\r\n  position: absolute;\r\n  top: 5px;\r\n  left: 0;\r\n}\r\n\r\nspan.required {\r\n  display: inline-block;\r\n  margin-left: 2px;\r\n  font-size: 1rem\r\n}\r\n\r\nlabel[required]:after,\r\nspan.required:after {\r\n  content: '*';\r\n  font-size: 110%;\r\n  color: red;\r\n}\r\n\r\n\r\n.alert-form-error {\r\n  white-space: pre-wrap !important;\r\n  font-size: 0.8rem;\r\n  padding: 7px 15px !important;\r\n}\r\n\r\n.form-control.error {\r\n  border-color: red !important;\r\n}\r\n\r\n\r\n\r\n.carret::after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-right: 2px solid black;\r\n  border-bottom: 2px solid black;\r\n  transform: rotate(225deg);\r\n  margin-left: 7px;\r\n  position: relative;\r\n  top: 1px;\r\n  transform: all 200ms;\r\n}\r\n\r\n.carret.desc::after {\r\n  transform: rotate(45deg);\r\n  top: -2px;\r\n}\r\n\r\n\r\n\r\ntable tfoot th,\r\ntable tfoot td {\r\n  font-weight: normal !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
